import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M4.548 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T4.548 4.5h11.385q.757 0 1.282.525t.525 1.283v4.577l2.747-2.746q.22-.222.497-.111.276.11.276.422v7.1q0 .312-.276.422t-.498-.11l-2.746-2.747v4.577q0 .758-.525 1.283t-1.282.525zm0-1.5h11.385a.3.3 0 0 0 .22-.087.3.3 0 0 0 .087-.22V6.307a.3.3 0 0 0-.086-.221.3.3 0 0 0-.221-.087H4.548a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v11.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .221.087"
    }, null, -1)
  ])))
}
export default { render: render }